import _ from 'lodash';
import moment from 'moment';
export default function formatDates(item, keys, useLocalTime, dateFormat) {
	const locale = window.navigator.userLanguage || window.navigator.language;
	moment.locale(locale);
	const localeData = moment.localeData();
	const format = dateFormat ? dateFormat : localeData.longDateFormat('L');

	_.each(keys, key => {
		if (_.has(item, key)) {
			_.set(
				item,
				key,
				_.get(item, key)
					? useLocalTime
						? moment(
								moment
									.utc(_.get(item, key))
									.toDate()
									.toISOString()
						  ).format(format)
						: moment(_.get(item, key)).format(format)
					: '-'
			);
		}
	});
}
